import { Container } from "react-bootstrap";
import LeafDivider from "../ui/LeafDivider";
import "../style/Hero.css";

const WHATSAPP_HREF =
  "https://api.whatsapp.com/send?phone=916363018056&text=Hi%2C%20I%27d%20like%20to%20know%20more%20about%20Bit%20Byte%20Foods%20batter.";
const BLINKIT_HREF =
  "https://blinkit.com/prn/bit-byte-foods-dosa-paddu-batter/prid/668300";

const Hero = () => {
  return (
    <section className="hero">
      <Container className="container-narrow hero__inner">
        <div className="hero__copy">
          <span className="font-kannada hero__greeting">ನಮಸ್ಕಾರ 👋</span>
          <h1 className="hero__title">
            Soft Idlis, Crispy Dosas
            <br />
            Ready in Minutes
          </h1>
          <p className="hero__subtitle">
            No soaking. No grinding. No waiting overnight. Just fresh,
            stone-ground batter made the way your grandmother made it —
            ready whenever breakfast is.
          </p>
          <div className="hero__badges">
            <span className="hero__badge">100% Natural</span>
            <span className="hero__badge">Freshly Prepared</span>
            <span className="hero__badge">No Preservatives</span>
          </div>
          <p className="hero__note">
            Also on{" "}
            <a href={BLINKIT_HREF} target="_blank" rel="noreferrer">
              Blinkit
            </a>{" "}
            in Raichur, Dharwad &amp; Belgaum.
          </p>
          <div className="hero__actions">
            <a href="#where-to-buy" className="btn-turmeric">
              Available in Stores &amp; on Blinkit
            </a>
            <a
              href={WHATSAPP_HREF}
              target="_blank"
              rel="noreferrer"
              className="btn-leaf-outline"
            >
              WhatsApp Us
            </a>
          </div>
        </div>
        <div className="hero__art hero__art--packet">
          <img
            src="/images/packetonpodium.jpeg"
            alt="Bit Byte Foods idli dosa batter packet"
            className="hero__photo hero__photo--packet"
            fetchpriority="high"
          />
        </div>
      </Container>
      <LeafDivider tone="var(--baale-white)" />
    </section>
  );
};

export default Hero;
